import Tab from '../../../components/_common/Tab'
import '../style.css'
import { useNavigate } from "react-router-dom";
import SearchModal from '../Search/SearchModal';
import { errorNotify } from '../../../services/toast.notification';
import { getLabInfo, getLabList } from '../../../api/api';
import { useEffect, useState } from 'react';
import { UpdateGeneralInfo } from '../../../redux/reducers/GeneralInfoSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/store/storehooks';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import jalali_moment from 'jalali-moment';
import Spinner from '../../../components/_common/Spinner';

const LabDetails = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [labInfo, setLabInfo] = useState({
        prk_AndriodLab_AutoID: 0,
        str_LabPersianName: "",
        str_DirectTel: "",
        str_WebSiteAddress: "",
        str_TelegramAddress: "",
        str_ServiceURL: "",

    });

    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();

    const USformatter = new Intl.NumberFormat("en-US");
    const _getLabInfo = (serviceUrl: any) => {

        getLabInfo(serviceUrl)
            .then((jsonResult: any) => {
                //let jsonResult = JSON.parse(JSON.stringify(result));
                //alert(jsonResult.CentralVer);
                let sqlVer = jsonResult.SQLVersion.split(" - ");
                dispatch(UpdateGeneralInfo({
                    CentralVer: jsonResult.CentralVer,
                    SQLVersion: sqlVer[0],
                    DsSQLBackupInfo: jsonResult.DsSQLBackupInfo.SqlBackup,
                    DreamLabSendInfo: jsonResult.DreamLabSendInfo.DreamLabSend,
                    ParsicMasterInfo: jsonResult.ParsicMasterInfo.ParsicMaster,
                    MyParsicServiceLog: jsonResult.MyParsicServiceLog,
                    hostname: jsonResult.hostname,
                    IISIpAddress: jsonResult.IISIpAddress,
                    SQLServerIP: jsonResult.SQLServerIP,
                    SMSRemainingCredit: jsonResult.SMSRemainingCredit,
                    SqlServerName: jsonResult.SqlServerName,
                    OsInfo: jsonResult.OsInfo[0],
                    WordVersion: jsonResult.WordVersion[0],
                    ParsicTempAccess: jsonResult.ParsicTempAccess,
                    GoogleConnection: jsonResult.GoogleConnection,
                    ParsiPolServiceConnection: jsonResult.ParsiPolServiceConnection,
                    SqlConnection: jsonResult.SqlConnection,
                    PadvishIsRunning: jsonResult.PadvishIsRunning,
                    PadvishIsInstalled: jsonResult.PadvishIsInstalled,
                    SQLIsInstalled: jsonResult.SQLIsInstalled,
                    PrintCatcherIsInstalled: jsonResult.PrintCatcherIsInstalled,
                    PwebserviceUserInSql: jsonResult.PwebserviceUserInSql,
                    SqlIPPing: jsonResult.SqlIPPing,
                    SqlRemotControlPort: jsonResult.SqlRemotControlPort,
                    CheckParsicSMSServiceStatus: jsonResult.CheckParsicSMSServiceStatus,
                    LastAutoBackupForLastWeek: jsonResult.LastAutoBackupForLastWeek,
                    InetsrvLogFolderIsExist: jsonResult.InetsrvLogFolderIsExist,
                }))
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const loadLabs = () => {
        // if (!myStore.labList.list) {
            getLabList()
                .then((result: any) => {
                    //setData(result.data.data);
                    //setFilteredData(result.data.data);
                    let selectedLab: any = result.data.data.find((lab: any) => lab.prk_AndriodLab_AutoID == myStore.auth.userId);
                    setLabInfo(selectedLab);
                    _getLabInfo(selectedLab.str_ServiceURL);
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
                })
        // }
        // else {
        //     let selectedLab: any = myStore.labList.list.find((lab: any) => lab.Prk_AndriodLab_AutoID == myStore.auth.userId);
        //     setLabInfo(selectedLab);
        //     _getLabInfo(selectedLab.str_ServiceURL);
        // }
    }

    useEffect(() => {
        loadLabs();


    }, []);


    return (


        <div className='row d-flex justify-content-around ' style={{ direction: "rtl", padding: "30px 10px" }}>
            {isLoading == false && (
                <>
                    <div className='col-md-2 d-flex flex-column'>
                        <div className="borderd-content">
                            <div className="title">اطلاعات آزمایشگاه</div>
                            <div className="labContent">
                                <div className='mb-3'><span className='general-info-color'>نام:</span><span style={{ float: 'left' }}>{labInfo.str_LabPersianName}</span></div>
                                <div className='mb-3'><span className='general-info-color'>تلفن:</span><span style={{ float: 'left' }}>{labInfo.str_DirectTel}</span></div>
                                <div className='mb-3'><span className='general-info-color'>سایت:</span><span style={{ float: 'left' }}>{labInfo.str_WebSiteAddress}</span></div>

                                <div className='mb-3'><span className='general-info-color'>ورژن سنترال:</span><span style={{ float: 'left' }}>{myStore.generalInfo.CentralVer}</span></div>
                                <div className='mb-3'><span className='general-info-color'>ورژن بانک:</span><span style={{ float: 'left', direction: 'ltr' }}>{myStore.generalInfo.SQLVersion}</span></div>
                                <div className='mb-3'><span className='general-info-color'> ورژن word</span><span style={{ float: 'left' }}>{myStore.generalInfo.WordVersion}</span></div>
                                <div className='mb-3'><span className='general-info-color'>باقیمانده پیامک (تومان) </span><span style={{ float: 'left' }}>{USformatter.format(Number(myStore.generalInfo.SMSRemainingCredit))}</span></div>


                            </div>
                        </div>

                        <div className="borderd-content">
                            <div className="title" style={{ backgroundColor: "yellow" }}>هشدارها </div>
                            <div className="labContent">

                                <div className='mb-3'>{myStore.generalInfo.DsSQLBackupInfo.length > 0 ? <span className='general-info-color'>آخرین بکاپ در تاریخ <span style={{ direction: 'rtl' }}>{jalali_moment(JSON.parse(JSON.stringify(myStore.generalInfo.DsSQLBackupInfo[0])).Date, 'YYYY-MM-DD').locale('fa').format('YYYY-MM-DD')}</span> با آدرس {JSON.parse(JSON.stringify(myStore.generalInfo.DsSQLBackupInfo[0])).Address} گرفته شده است.</span> : <span className='general-info-color'> در دو روز اخیر هیچ بکاپی گرفته نشده است.</span>}</div>
                                <div className='mb-3'>{myStore.generalInfo.DreamLabSendInfo.length > 0 ? <span className='general-info-color'>آخرین دریم در آدرس {JSON.parse(JSON.stringify(myStore.generalInfo.DreamLabSendInfo[0])).URL} انجام شده است.</span> : null}</div>
                                <div className='mb-3'>{myStore.generalInfo.OsInfo.toString().includes("Windows 10 Enterprise") ? null : <span className='general-info-color'>ویندوز وب سرور آزمایشگاه پشتیبانی نمی شود.</span>}</div>
                                <div className='mb-3'>{myStore.generalInfo.ParsicTempAccess.length > 0 ? <span className='general-info-color'>  این آزمایشگاه از دماسنج های شرکت استفاده می کند.  </span> : <span className='general-info-color'> این آزمایشگاه از دماسنج های شرکت استفاده نمی کند.</span>}</div>


                            </div>
                        </div>
                    </div>
                    <div className='col-md-8 d-flex flex-column'>
                        <Tab url={labInfo.str_TelegramAddress} labId={labInfo.prk_AndriodLab_AutoID} service_url={labInfo.str_ServiceURL} />
                    </div>
                    <div className='col-md-2 d-flex flex-column'>
                        <div className="borderd-content" style={{ direction: 'ltr' }}>
                            <div className="title"> </div>
                            <div className="labContent" >

                                <div className='mb-3'>
                                    <span style={{ fontSize: '14px' }}>Internet</span>
                                    <span style={{ float: 'right' }}>{myStore.generalInfo.GoogleConnection ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span>
                                </div>
                                <div className='mb-3'>
                                    <span style={{ fontSize: '14px' }}>Padvish Installed</span>
                                    <span style={{ float: 'right' }}>{myStore.generalInfo.PadvishIsInstalled ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span>
                                </div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Padvish Running?</span><span style={{ float: 'right' }}>{myStore.generalInfo.PadvishIsRunning ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>PrintCatcher Installed?</span><span style={{ float: 'right' }}>{myStore.generalInfo.PrintCatcherIsInstalled ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Sql Connection</span><span style={{ float: 'right' }}>{myStore.generalInfo.SqlConnection ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>SQL Installed?</span><span style={{ float: 'right' }}>{myStore.generalInfo.SQLIsInstalled ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>ParsiPol Service Connection</span><span style={{ float: 'right' }}>{myStore.generalInfo.ParsiPolServiceConnection ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>PwebserviceUserInSql</span><span style={{ float: 'right' }}>{myStore.generalInfo.PwebserviceUserInSql ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Sql IP Ping</span><span style={{ float: 'right' }}>{myStore.generalInfo.SqlIPPing ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Sql Remot Control Port</span><span style={{ float: 'right' }}>{myStore.generalInfo.SqlRemotControlPort ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Check Parsic SMS Service</span><span style={{ float: 'right' }}>{myStore.generalInfo.CheckParsicSMSServiceStatus ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>LastAutoBackup LastWeek</span><span style={{ float: 'right' }}>{myStore.generalInfo.LastAutoBackupForLastWeek ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>InetsrvLogFolder Exist?</span><span style={{ float: 'right' }}>{myStore.generalInfo.InetsrvLogFolderIsExist ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>

                            </div>
                        </div>

                        <div className="borderd-content" style={{ direction: 'rtl' }}>
                            <div className="title"> بررسی صحت وب آزمایشگاه </div>
                            <div className="labContent" >
                                <div className='mb-3'>
                                    <span style={{ fontSize: '14px' }}>بررسی صحت NewLabOnline </span>
                                    <span style={{ float: 'left' }}><a href={labInfo.str_WebSiteAddress} target='_blank' rel="noreferrer">
                                        {labInfo.str_WebSiteAddress}
                                    </a>
                                    </span>
                                </div>
                                <div className='mb-3' style={{ borderTop: '1px solid lightgray', paddingTop: '10px' }}>
                                    <span style={{ fontSize: '14px' }}> بررسی صحت LabAndroid</span>
                                    <span style={{ float: 'left' }}><a href={labInfo.str_ServiceURL} target='_blank' rel="noreferrer">
                                        {labInfo.str_ServiceURL}
                                    </a>
                                    </span>
                                </div>
                                <div className='mb-3' style={{ borderTop: '1px solid lightgray', paddingTop: '10px' }}>
                                    <span style={{ fontSize: '14px' }}>بررسی صحت NewLabAndroid</span>
                                    <span style={{ float: 'left' }}><a href={labInfo.str_TelegramAddress} target='_blank' rel="noreferrer">
                                        {labInfo.str_TelegramAddress}
                                    </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SearchModal url={labInfo.str_TelegramAddress} serviceUrl={labInfo.str_ServiceURL}/>
                </>
            )
            }
            {
                isLoading === true && (
                    <Spinner />
                )
            }
        </div>
    )
}

export default LabDetails;

